<template>
  <Modal v-model="openForm" :title="title" footer-hide width="700" height="400"
    ><Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
      <Table id="lytable" border :columns="forms" :data="tableData">
        <div
          style="padding: 10px 0"
          slot-scope="{ row, index }"
          slot="aaaa"
        ></div>
        <template slot-scope="{ row, index }" slot="number">
          <Input type="number" v-model="tableData[index].number"></Input>
        </template>

        <template slot-scope="{ row, index }" slot="time">
          <lyyymmdd v-model="tableData[index].time"></lyyymmdd>
        </template>
        <template slot-scope="{ row, index }" slot="progress">
          <Select v-model="tableData[index].progress" style="width: 100%">
            <Option
              :value="y"
              v-for="(y, index1) in progresses"
              :key="index1"
              :label="y"
            >
              <span>{{ y }}</span>
            </Option>
          </Select>
        </template>
      </Table>
      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="save('item')">提交表单</Button>
          </div>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
import fields from "./fields";
export default {
  data() {
    return {
      openForm: false,
      ruleValidate: {},
      item: {
        careId: "",
        item: "日常保洁",
        progress: "已完成",
        time: Date.now(),
        content: "",
        dept: "",
        name: "日常保洁",
        number: 1,
        remark: "",
        unit: "工日",
      },
      forms: [],
      selects: {
        unit: ["工日", "台班"],
        item: [
          "日常保洁",
          "日常巡查",
          "夜巡视",
          "清洗伸缩缝",
          "清理疏通排水沟、泄水孔",
          "清理疏通积水点",
          "清洗标志标牌、防撞墙、水马等",
          "绿化浇水",
          "路面洒水清洗",
          "绿化除草、修剪、杀虫",
          "绿化施肥",
        ],
      },
      title: "",
      tableData: [
        {
          item: "人工保洁",
          unit: "工日",
          progress: "未进行",
          number: 0,
          time: Date.now(),
        },
        {
          item: "巡查车",
          unit: "台班",
          progress: "未进行",
          number: 0,
          time: Date.now(),
        },
        {
          item: "扫地车",
          unit: "台班",
          progress: "未进行",
          number: 0,
          time: Date.now(),
        },
        {
          item: "洒水车",
          unit: "台班",
          progress: "未进行",
          number: 0,
          time: Date.now(),
        },
      ],
      progresses: ["已完成", "未进行"],
    };
  },
  methods: {
    reach(v) {
      this.openForm = true;
      this.forms = fields[v.key];
      this.item.careId = v.docId;
      this.rule();
      this.title = v.name;
      this.detail = false;
    },
    save(name) {
      //this.item.time = this.utils.toSjc(this.item.time1);
      this.item.content = JSON.stringify(this.tableData);
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-rmm-server-dpm/care/execution/add",
            data: this.item,
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.$Message.success("提交成功");
            }
          });
        }
      });
    },
    check(name) {
      this.aaaaaa = false;
      this.$refs[name].validate((valid) => {
        this.aaaaaa = valid;
        if (!valid) {
          alert(this.title + "未完善");
        }
      });
    },
    readCheck() {
      this.check("item");
      return this.aaaaaa;
    },
    rule() {
      var arr = this.forms;
      var abc = {};

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].required) {
          abc[arr[i].key1] = { required: true, message: "必填" };
        }
      }
      this.ruleValidate = abc;
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yhgl/forms/dailyRecord.vue